import React from 'react'

import IntegrityPact from 'app/PemetaanKompetensiPage/pages/IntegrityPact'
import PageHeader from 'app/PemetaanKompetensiPage/components/PageHeader'
import { checkDateTimeServer } from 'app/PemetaanKompetensiPage/utils'

export async function getServerSideProps() {
  const currentDateTimeServer = await checkDateTimeServer()
  return {
    props: { currentDateTimeServer }, // will be passed to the page component as props
  }
}

const IntegrityPactPage = ({ currentDateTimeServer }) => {
  return <IntegrityPact currentDateTimeServer={currentDateTimeServer} />
}

const IntegrityPactPageHeader = () => <PageHeader title="Pakta Integritas" />

IntegrityPactPage.layoutOpts = {
  hasHeader: true,
  className: 'text-default bg-gray-10 !max-w-full !h-full min-h-screen',
  header: IntegrityPactPageHeader,
}
export default IntegrityPactPage
